module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f52aaddde48ca7dfd58708fd379c5a1.png";